import { render, staticRenderFns } from "@/manager/client/views/clientEdit/noteItemClient/noteItemClient.pug?vue&type=template&id=c0edca28&scoped=true&lang=pug&external"
import script from "./noteItemClient.view.vue?vue&type=script&lang=ts"
export * from "./noteItemClient.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/client/views/clientEdit/noteItemClient/noteItemClient.scss?vue&type=style&index=0&id=c0edca28&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0edca28",
  null
  
)

export default component.exports